import { useQuery } from '@tanstack/react-query'

import { DEFAULT_THEME } from '@apps-common/config/theme'
import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { hydrateTheme } from '@apps-common/theme/hydrateTheme'
import type { PortalThemeModel } from '@apps-common/types/portal/theme'

export const QUERY_GET_MY_MONITORING_THEME = (companyId?: string) => ['getMyMonitoringTheme', companyId]

const getMyMonitoringTheme = async (companyId?: string): Promise<PortalThemeModel> => {
  const res = await axios.get(`/my-monitoring/Theme/GetMyMonitoringTheme?companyId=${companyId ?? ''}`)
  const theme = res?.data?.data as PortalThemeModel | undefined

  if (theme) return hydrateTheme(theme)

  return DEFAULT_THEME
}

type QueryFnType = typeof getMyMonitoringTheme

type Props = {
  config?: QueryConfig<QueryFnType>
  companyId?: string
}

export const useGetMyMonitoringTheme = ({ config, companyId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    gcTime: 0,
    queryKey: QUERY_GET_MY_MONITORING_THEME(companyId),
    queryFn: () => getMyMonitoringTheme(companyId)
  })
